export enum DefaultValue {
  ActiveElementScale = 0.98,
  BorderRadius = '8px',
  ContainerWidth = '1500px',
  FontFamily = "'Inter', sans-serif",
  TransitionDuration = '0.1s',
  TransitionTimingFunction = 'ease-out',
}
